import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { createContact } from '../actions'
import moment from 'moment'
import ContactForm, { ContactFormValidations } from './form'

class ContactAdd extends Component {
  static formSubmit(dispatch, formId, values, changed) {
    dispatch(createContact(formId, values.toJS()))
  }

  static formValidation = ContactFormValidations

  componentWillMount = () => {
    let { project, interview, order, organization, organization_id, formInit, user_id, task_type_id } = this.props
    // console.log(this.props)

    let initialValues = {}

    if (project) initialValues.projects = [project.get('id')]

    if (interview) initialValues.interviews = [interview.get('id')]

    if (order) initialValues.orders = [order.get('id')]

    if (organization) initialValues.organizations = [organization.get('id')]

    if (organization_id) initialValues.organizations = [organization_id]

    formInit(initialValues)
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose } = this.props
    // console.log(this.props)

    let actions = (
      <Button
        size="tiny"
        color="green"
        content="Tallenna"
        onClick={e => e.preventDefault() & formSubmit()}
        icon="save"
      />
    )

    return (
      <ModalForm id="task-add" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <ContactForm {...this.props} title="Lisää yhteyshenkilö" />
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connectForm('contact-add', ContactAdd, mapStateToProps, mapDispatchToProps)
